import React, { useEffect, useRef, useState } from 'react';
import { getDataUTC, is3CatInfoVerificacio } from '@portal-internet/core';
import { getDirecte } from 'utils/canals';
import { getNaturalDate } from 'utils/3catinfo/dateHelper';
import { useViewport } from 'hooks/3catinfo/useViewport';
import Enllac from 'components/3catinfo/Enllac';
import Imatge from 'components/3catinfo/Imatge';
import Players from 'components/3catinfo/Players';
import IconaMedia from 'components/3catinfo/IconaMedia';
import AfegeixALaLlista from 'components/3catinfo/AfegeixALaLlista';
import Etiquetes from 'components/3catinfo/Etiquetes';
import Etiqueta from 'components/3catinfo/Etiqueta';
import clsx from 'clsx';
import __get from 'lodash/get';
import __isEmpty from 'lodash/isEmpty';
import styles from './destacatBasic.module.scss';

const DataPublicacio = (props) => {
    const { mostrarData, date } = props;
    return mostrarData && date ? (
        <time dateTime={getDataUTC(date)} className={styles.dataPub}>
            {getNaturalDate(date)}
        </time>
    ) : (
        <></>
    );
};

const MediaImatge = (props) => {
    const { item, tema, priorityImage, numColumnsRow, estil, tipusImatge, index: indexRanking, playerEmbedat } = props;
    const { id, imatges, tags, agrupacions, videos, audios, canals_directes_embedats, mediadestacat, finalitzat } = item || props;
    const isVerifica = is3CatInfoVerificacio(tags);

    const styleWrapper = clsx({
        [styles.imatgeWrapper]: true,
        [styles[tema]]: !!tema
    });

    const etiqueta =
        canals_directes_embedats || finalitzat === false ? (
            <div className={styles.labelWrapper} data-testid='etiqueta'>
                <Etiqueta className={styles.labelDirecte} text='En directe' icona='directes' isBlanc={true} tipus='highlight' />
            </div>
        ) : (
            <div className={styles.labelWrapper} data-testid='etiqueta'>
                <Etiquetes agrupacions={agrupacions} tags={tags} id={id} />
            </div>
        );

    if (playerEmbedat && !__isEmpty(canals_directes_embedats)) return <></>;
    if (!playerEmbedat || __isEmpty(videos)) {
        return (
            <div className={styleWrapper} data-testid='destacat-content-imatge'>
                {estil !== 'ranking' ? etiqueta : isVerifica && etiqueta}
                {estil === 'ranking' && indexRanking && (
                    <div className={styles.numRanking}>
                        <span>{indexRanking}</span>
                    </div>
                )}
                <IconaMedia
                    videos={videos}
                    audios={audios}
                    canals_directes_embedats={canals_directes_embedats}
                    mediadestacat={mediadestacat}
                />
                <Imatge
                    imatges={imatges}
                    className={styles.imatge}
                    tipus={tipusImatge}
                    numColumnsRow={numColumnsRow}
                    aria-hidden='true'
                    layout='fill'
                    objectFit='cover'
                    priority={priorityImage}
                    crop='1903'
                    data_testid='destacat-img'
                />
            </div>
        );
    } else {
        return <></>;
    }
};

const MediaVideo = (props) => {
    const { item, priorityImage, numColumnsRow, playerEmbedat } = props;
    const { canals_directes_embedats, videos, imatges, titol } = item || props;
    const [amagarEtiqueta, setAmagarEtiqueta] = useState(false);
    const [videoActive, setVideoActive] = useState(true);

    const pushMediaModel = (mediaModel) => {
        const duradaMediaModel =
            __get(mediaModel, 'attributes.informacio.attributes.arafem.attributes.durada.text') ||
            __get(mediaModel, 'attributes.informacio.attributes.arafem.durada.text');
        const geoBlocked = __get(mediaModel, 'attributes.geoblocked');
        setVideoActive(duradaMediaModel !== '' && !geoBlocked);
    };

    const amagarEtiquetaHandler = (state) => {
        setAmagarEtiqueta(state);
    };

    if (!videoActive) {
        return <MediaImatge {...props} playerEmbedat={false} />;
    }

    if (playerEmbedat && !__isEmpty(canals_directes_embedats)) {
        return (
            <>
                <div className={styles.mediaVideo} data-testid='destacat-video-directe'>
                    <Players
                        id={getDirecte(canals_directes_embedats[0])?.canal}
                        tipus='video-directe'
                        autoPlay={false}
                        mostrarBotonsAccessibilitat={false}
                        eliminarPrimerTabIndex={true}
                        ocultaInfo={amagarEtiquetaHandler}
                        pushMediaModel={pushMediaModel}
                        tagIdPrefix={props.redlAuxInfo?.replaceAll('|', '-')?.toLowerCase() || 'destacat-basic'}
                    />
                </div>
                {!amagarEtiqueta && (
                    <div className={styles.labelWrapper} data-testid='etiqueta'>
                        <Etiqueta
                            className={styles.labelDirecte}
                            text='En directe'
                            icona='directes'
                            isBlanc={true}
                            tipus='highlight'
                        />
                    </div>
                )}
            </>
        );
    } else if (playerEmbedat && !__isEmpty(videos)) {
        return (
            <Players
                id={videos[0].id}
                tipus='destacat'
                imatges={videos[0]?.imatges || imatges}
                numColumnsRow={numColumnsRow}
                priorityImage={priorityImage}
                testId='noticia-media-video'
            />
        );
    }

    return <></>;
};

const Avantitol = (props) => {
    const { mostraComarca, mostraPrograma, mostraTematica, playerEmbedat, item } = props;
    const { programes_tv, programes_radio, tags, comarques, videos, canals_directes_embedats } = item;

    const programa = programes_tv?.[0]?.desc || programes_radio?.[0]?.desc;
    const comarca = comarques?.[0]?.desc;
    const mainTheme = tags?.find((t) => t.main)?.desc?.toUpperCase();
    const isVerifica = is3CatInfoVerificacio(tags);
    const isAvantitol = isVerifica || (mostraComarca && !isVerifica) || (mostraPrograma && programa && !isVerifica);

    const styleAvantitol = clsx(
        styles.avantitol,
        isAvantitol && playerEmbedat && (!__isEmpty(videos) || !__isEmpty(canals_directes_embedats)) && styles.avantitolPlayer
    );

    return (
        <>
            {isVerifica && <div className={styleAvantitol}>3catinfo verifica</div>}
            {!isVerifica && mostraComarca && comarca && <div className={styleAvantitol}>{comarca}</div>}
            {mostraTematica && mainTheme && <span className={styles.tematica}>{mainTheme}</span>}
            {!isVerifica && mostraPrograma && programa && <div className={styleAvantitol}>{programa}</div>}
        </>
    );
};

const Peu = (props) => {
    const { lloc, autors } = props;
    const stylesPeu = clsx(styles.lloc, !__isEmpty(autors) && styles.ambAutor);

    if (__isEmpty(autors) && __isEmpty(lloc)) return <></>;

    return (
        <div>
            {!__isEmpty(autors) && (
                <span className={styles.autors}>
                    {autors.map((item, i) => {
                        const isFirst = i === 0 && autors.length > 1;
                        const isLast = i === autors.length - 1;
                        const routeAutor = { slug: item?.nom, id: item?.id, tipologia: item?.tipologia, domini: item.domini };
                        return (
                            <React.Fragment key={item.id}>
                                {!isLast && !isFirst && ', '}
                                {isLast && autors.length > 1 && ' i '}
                                <Enllac route={routeAutor} className={styles.enllacAutor}>
                                    {item.nom}
                                </Enllac>
                            </React.Fragment>
                        );
                    })}
                </span>
            )}
            {!__isEmpty(lloc) && <span className={stylesPeu}>{lloc}</span>}
        </div>
    );
};

const DestacatBasic = (props) => {
    const {
        item,
        routePath,
        testId,
        estil,
        inMosaic,
        className,
        numColumnsRow,
        tag,
        tagPrincipal,
        mostraComarca,
        mostraTematica,
        mostraPrograma,
        mostrarData,
        mostraAfegirBookmark,
        accioMostraAfegirBookmark,
        focusOnMount,
        showMissatgeEliminat,
        marcatgeAudienciesClick
    } = props;

    const {
        id,
        titol,
        permatitle,
        tipologia,
        data_publicacio,
        isUltimaHora,
        autors,
        lloc,
        tags,
        domini,
        programes_tv,
        programes_radio,
        canals_directes_embedats,
        videos
    } = item || props;
    const playerEmbedat = String(props.playerEmbedat).toLowerCase() === 'true';
    const ref = useRef(null);
    const isVerifica = is3CatInfoVerificacio(tags);

    const TagSeo = tag;
    let TagPrincipal = tagPrincipal;
    let programa = programes_tv?.[0]?.desc || programes_radio?.[0]?.desc;
    const isAvantitol = isVerifica || (mostraComarca && !isVerifica) || (mostraPrograma && programa && !isVerifica);

    const { redlAuxState = {} } = item || props;
    const { isRedlId, isRedlTipologia } = redlAuxState;
    const [hasRedlParams, setHasRedlParams] = useState(false);
    const { zoomNavigator } = useViewport();
    const route = { slug: permatitle || titol, id, tipologia, type: routePath, domini };

    useEffect(() => {
        if (isRedlId || isRedlTipologia) {
            setHasRedlParams(true);
        }
    }, [isRedlId, isRedlTipologia]);

    useEffect(() => {
        if (focusOnMount && ref.current) {
            ref.current.focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const styleCos = clsx(styles.cos, hasRedlParams && styles.hasRedlParams, zoomNavigator > 2 && styles.ambZoom);

    const stylesDestacat = clsx(
        styles.destacatBasic,
        inMosaic && styles.inMosaic,
        mostraAfegirBookmark && styles.bookmark,
        estil && styles[estil],
        numColumnsRow > 0 && styles['col' + numColumnsRow],
        className
    );

    const styleContent = clsx(styles.content);

    const styleTitol = clsx(
        styles.titol,
        playerEmbedat && (!__isEmpty(videos) || !__isEmpty(canals_directes_embedats)) && !isAvantitol && styles.titolPlayer
    );

    if (!titol) {
        return <></>;
    }

    return (
        <TagPrincipal key={`destacat-basic-${id}`} className={stylesDestacat} {...(testId && { 'data-testid': testId })}>
            <MediaVideo {...props} playerEmbedat={playerEmbedat} />
            <Enllac
                route={route}
                dataTestId='destacat-enllac'
                ref={ref}
                tabIndex='0'
                marcatgeAudienciesClick={marcatgeAudienciesClick}
            >
                <div className={styleCos}>
                    <div className={styleContent}>
                        <MediaImatge {...props} playerEmbedat={playerEmbedat} />
                        <Avantitol
                            mostraComarca={mostraComarca}
                            mostraPrograma={mostraPrograma}
                            mostraTematica={mostraTematica}
                            playerEmbedat={playerEmbedat}
                            item={item || props}
                        />
                        <TagSeo className={styleTitol}>
                            {isUltimaHora && (
                                <span className={styles.labelUltimahora} data-testid='etiqueta-text-al-titol'>
                                    Última hora
                                </span>
                            )}

                            <span data-testid='destacat-titol' dangerouslySetInnerHTML={{ __html: titol }}></span>
                        </TagSeo>
                        <DataPublicacio mostrarData={mostrarData} date={data_publicacio} className={styles.dataPub} />
                    </div>
                </div>
            </Enllac>
            <Peu lloc={lloc} autors={autors} />

            {!!mostraAfegirBookmark && (
                <AfegeixALaLlista
                    tipologia={tipologia}
                    id={id}
                    estil='destacat'
                    isBlanc={false}
                    accioMostraAfegirBookmark={accioMostraAfegirBookmark}
                    showMissatgeEliminat={showMissatgeEliminat}
                />
            )}
        </TagPrincipal>
    );
};

DestacatBasic.defaultProps = {
    priorityImage: false,
    playerEmbedat: false,
    tipusImatge: 'web_destacat',
    mostraComarca: false,
    numColumnsRow: 0,
    tag: 'h3',
    tagPrincipal: 'article'
};

export default DestacatBasic;
